@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.pill {
  display: inline-block;
  vertical-align: top;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: @pill--background-color;
  min-height: 24px;
  font-size: 14px;
  line-height: 16px;
  color: @pill--text-color;
  position: relative;

  svg {
    fill: @pill--fill-color;
  }

  &.no-status,
  &.tag {
    font-size: 12px;
    line-height: 16px;

    .icon-wrapper {
      height: 16px;
      width: 16px;
      margin-right: -3px;
    }
  }

  &.planned {
    background-color: @pill--planned--background-color;
  }

  &.white-text,
  &.shipped,
  &.on-hold {
    color: @pill--light--text-color;
    svg {
      color: @pill--light--fill-color;
    }
  }

  &.shipped {
    background-color: @pill--shipped--background-color;
  }

  &.on-hold {
    background-color: @pill--on-hold--background-color;
  }

  &.cancelled {
    background: transparent;
    color: @pill--cancelled--text-color;
  }

  &.awaiting-shipment,
  &.awaiting-fulfillment {
    background: @pill--awaiting-shipment--background-color;
  }

  &.awaiting-payment {
    background: @pill--awaiting-payment--background-color;
  }

  &.truncate {
    .pill-content {
      > span {
        .truncate();
      }
    }
  }

  &.white-tag {
    border: 1px solid @pill--light-tag--border-color;
    padding-bottom: 4px;
    padding-top: 4px;
  }

  &.collapsed {
    height: 18px;
    min-height: 18px;
    border-radius: 4px;
    width: 7px;
    padding: 0;
  }
}

.pill-content {
  display: flex;
  align-items: center;
}

.icon-wrapper {
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-left: 5px;
  position: relative;
  margin-right: -5px;
}

.icon {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.37);

  > svg {
    height: 100%;
    width: 100%;
  }
}

.neutral {
  font-size: 12px;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  border-color: var(--grey-500-base);
  background-color: var(--grey-000);
  color: var(--grey-800-base);
  padding: 0 8px;
  min-height: 16px;
}

.enabled {
  font-size: 12px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--green-300);
  background-color: var(--green-200);
  padding: 0 @space-8;
  display: flex;
  align-items: center;
}
